<div class="px-4 py-4 sidebar-container">
  <div class="sidebar-content">
    <a routerLink="/" class="return-btn cursor-pointer"><i class="fas fa-arrow-left"></i> Voltar</a>
    <div class="profile-card">
      <img alt="profile-example"
        [src]="_authService.loggedUser?.imageURL ? _authService.loggedUser?.imageURL : 'assets/icons/camera.svg'"
        style="border-radius: 50px; height: 32px; width: 32px" />
      <h4>{{ _authService.loggedUser?.firstName }} {{ _authService.loggedUser?.lastName }}</h4>
      <a>{{ _authService.loggedUser?.email }}</a>
      <a>criado em {{ _authService.loggedUser?.createdAt | date: "dd/MM/yyyy" }}</a>
    </div>
    <div class="sidebar-nav-item" routerLink="/profile" routerLinkActive="active-link">
      <i class="far fa-user fa-lg"></i>
      <a>Perfil</a>
    </div>
    <div class="sidebar-nav-item" routerLink="/organization" routerLinkActive="active-link">
      <i class="fa-regular fa-briefcase-blank fa-lg"></i>
      <a>Organização</a>
    </div>
    <div class="sidebar-nav-item" routerLink="/permission" routerLinkActive="active-link"
       *appCan="'profiles:read'">
      <i class="far fa-user-lock fa-lg"></i>
      <a>Permissões</a>
    </div>
    <div class="sidebar-nav-item" routerLink="/contracts" routerLinkActive="active-link"
       *appCan="'contracts:read'">
      <i class="fa-regular fa-memo fa-lg"></i>
      <a>Contratos</a>
    </div>
    <div class="sidebar-nav-item" routerLink="/contracted-company" routerLinkActive="active-link"
       *appCan="'contracted_companies:read'">
      <i class="fa-regular fa-building fa-lg"></i>
      <a>Empresas</a>
    </div>
  </div>
</div>